var map = {
	"./modules/events/events.module.ngfactory": [
		"1019",
		11
	],
	"./modules/fair/fair.module.ngfactory": [
		"Rnnf",
		12
	],
	"./pages/about/about.module.ngfactory": [
		"CcAJ",
		13
	],
	"./pages/add-deliveryagent/add-deliveryagent.module.ngfactory": [
		"2BFq",
		14
	],
	"./pages/add-member/add-member.module.ngfactory": [
		"xa4g",
		15
	],
	"./pages/admin-menu/admin-menu.module.ngfactory": [
		"2zlj",
		16
	],
	"./pages/admin-orders/admin-orders.module.ngfactory": [
		"awmQ",
		17
	],
	"./pages/book-a-table/book-a-table.module.ngfactory": [
		"Qap9",
		18
	],
	"./pages/bycategory/bycategory.module.ngfactory": [
		"wcaX",
		19
	],
	"./pages/cancel-order/cancel-order.module.ngfactory": [
		"KuWd",
		20
	],
	"./pages/category-slider/category-slider.module.ngfactory": [
		"cGTz",
		21
	],
	"./pages/catering-menu/catering-menu.module.ngfactory": [
		"t2k6",
		0,
		23
	],
	"./pages/catering/catering.module.ngfactory": [
		"HaDw",
		22
	],
	"./pages/check-in/check-in.module.ngfactory": [
		"PH3d",
		24
	],
	"./pages/choose-city/choose-city.module.ngfactory": [
		"rGdr",
		25
	],
	"./pages/coupons/coupons.module.ngfactory": [
		"pXS3",
		26
	],
	"./pages/create-record/create-record.module.ngfactory": [
		"lTVk",
		27
	],
	"./pages/customer-orders/customer-orders.module.ngfactory": [
		"W6v1",
		28
	],
	"./pages/daily-specials/daily-specials.module.ngfactory": [
		"5EXx",
		29
	],
	"./pages/deliveries-detail/deliveries-detail.module.ngfactory": [
		"nW3Y",
		31
	],
	"./pages/deliveries/deliveries.module.ngfactory": [
		"D6DD",
		30
	],
	"./pages/edit-order/edit-order.module.ngfactory": [
		"EbWz",
		32
	],
	"./pages/edit-profile/edit-profile.module.ngfactory": [
		"QVM1",
		33
	],
	"./pages/favorites/favorites.module.ngfactory": [
		"NApv",
		34
	],
	"./pages/googleplaces-detail/googleplaces-detail.module.ngfactory": [
		"dX9L",
		35
	],
	"./pages/help/help.module.ngfactory": [
		"N0qe",
		36
	],
	"./pages/home-location/home-location.module.ngfactory": [
		"IE9Q",
		37
	],
	"./pages/home-results/home-results.module.ngfactory": [
		"dRtE",
		38
	],
	"./pages/latest-orders/latest-orders.module.ngfactory": [
		"W5ae",
		39
	],
	"./pages/login/login.module.ngfactory": [
		"/yGZ",
		40
	],
	"./pages/menu-type/menu-type.module.ngfactory": [
		"fo1A",
		41
	],
	"./pages/modal/adminmenudet/adminmenudet.module.ngfactory": [
		"uMbC",
		42
	],
	"./pages/modal/cart/cart.module.ngfactory": [
		"AFww",
		43
	],
	"./pages/modal/coupon/coupon.module.ngfactory": [
		"zEAU",
		44
	],
	"./pages/modal/extras/extras.module.ngfactory": [
		"lvMF",
		45
	],
	"./pages/modal/guest-login/guest-login.module.ngfactory": [
		"64FJ",
		46
	],
	"./pages/modal/info/info.module.ngfactory": [
		"IujE",
		47
	],
	"./pages/modal/review/review.module.ngfactory": [
		"xZ33",
		48
	],
	"./pages/modal/search-filter/search-filter.module.ngfactory": [
		"g9Qg",
		49
	],
	"./pages/order-confirmation/order-confirmation.module.ngfactory": [
		"yp29",
		50
	],
	"./pages/order-summary/order-summary.module.ngfactory": [
		"ReTw",
		51
	],
	"./pages/payment-link/payment-link.module.ngfactory": [
		"wLe+",
		52
	],
	"./pages/payment-options/payment-options.module.ngfactory": [
		"lWFi",
		53
	],
	"./pages/platform-access/platform-access.module.ngfactory": [
		"7yPF",
		54
	],
	"./pages/privacy-policy/privacy-policy.module.ngfactory": [
		"NDCP",
		55
	],
	"./pages/refer-afriend/refer-afriend.module.ngfactory": [
		"qIT2",
		56
	],
	"./pages/refund-requests/refund-requests.module.ngfactory": [
		"v5YX",
		57
	],
	"./pages/refundorder-detail/refundorder-detail.module.ngfactory": [
		"nmsO",
		58
	],
	"./pages/register/register.module.ngfactory": [
		"1sqi",
		59
	],
	"./pages/report/report.module.ngfactory": [
		"jYds",
		60
	],
	"./pages/resdetail/resdetail.module.ngfactory": [
		"U8I5",
		0,
		61
	],
	"./pages/restaurant-detail/restaurant-detail.module.ngfactory": [
		"ylCU",
		0,
		62
	],
	"./pages/reviews-admin/reviews-admin.module.ngfactory": [
		"5Yhs",
		63
	],
	"./pages/settings/settings.module.ngfactory": [
		"zDS7",
		64
	],
	"./pages/store-management/store-management.module.ngfactory": [
		"y0Qp",
		65
	],
	"./pages/support/support.module.ngfactory": [
		"w4GT",
		66
	],
	"./pages/tax/tax.module.ngfactory": [
		"aUQ9",
		67
	],
	"./pages/terms-of-service/terms-of-service.module.ngfactory": [
		"9p4X",
		68
	],
	"./pages/time-slots/time-slots.module.ngfactory": [
		"DK3G",
		69
	],
	"./pages/tip/tip.module.ngfactory": [
		"HSA/",
		70
	],
	"./pages/togo-menu/togo-menu.module.ngfactory": [
		"2FfW",
		0,
		71
	],
	"./pages/u-businessimages/u-businessimages.module.ngfactory": [
		"vc/t",
		72
	],
	"./pages/update-record/update-record.module.ngfactory": [
		"auFR",
		73
	],
	"./pages/workin-progress/workin-progress.module.ngfactory": [
		"x4tI",
		74
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "crnd";
module.exports = webpackAsyncContext;